import * as React from "react";
import { Account, useAppSelector, useDriveSocket, useDefaultCollectionInfo, useDriveSubscribe, useWatchSocket } from "src/common";
import { WebsocketStatus } from "src/store";
import { RootState } from "src/store/configureStore";

// Description: Web Drive Initialize sets up the app for web use through websocket
function WebDriveInitializeComponent(props: { current_account: Account }) {
  const { current_account } = props;
  const ws_status = useAppSelector((state: RootState) => state.websocket.drive_ws_status);
  const default_permissions = useAppSelector((state: RootState) => state.drive.default_permissions);
  const collection_id = useAppSelector((state: RootState) => state.drive.current_directory?.collection_id);
  useDriveSocket();
  useWatchSocket();
  useDefaultCollectionInfo(current_account, default_permissions, ws_status === WebsocketStatus.connected);
  useDriveSubscribe(current_account, collection_id, default_permissions);
  return null;
}

export default React.memo(WebDriveInitializeComponent);
